import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import 'github-markdown-css';
import MarkdownIt from 'markdown-it';
import { writeClipboard } from "../../../../lib/utils";
import { INJECT_UICORE_BUS } from "../../../../lib/utils/consts";
import { selectText } from "../../../../lib/utils/browser/selectText";
import { memoize } from "lodash-es";
const getMarkdownIt = memoize( /** @param {{ html?: boolean, breaks?: boolean }} opts */
opts => new MarkdownIt(opts), x => [!!x.html, !!x.breaks].join('/'));
const Markdown = {
  name: 'markdown',
  model: {
    prop: 'source'
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    }
  },
  props: {
    align: {
      type: String,
      default: 'left'
    },
    source: {
      type: String
    },
    allowHtml: {
      type: Boolean,
      default: true
    },
    breaks: {
      type: Boolean,
      default: false
    },
    // render \n into <br/>
    openInNewWindow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    outHtml() {
      try {
        const md = getMarkdownIt({
          html: !!this.allowHtml,
          breaks: !!this.breaks
        });
        return md.render(this.source);
      } catch (er) {
        return '';
      }
    }
  },
  methods: {
    handleClick(ev) {
      var _ev$target$tagName;
      const tag = (_ev$target$tagName = ev.target.tagName) === null || _ev$target$tagName === void 0 ? void 0 : _ev$target$tagName.toLowerCase();
      if (tag === 'code') {
        var _this$uc;
        writeClipboard(ev.target.textContent);
        (_this$uc = this.uc) === null || _this$uc === void 0 || _this$uc.$message.success('已复制');
        selectText(ev.target);
        return;
      }
      const link = ev.target.closest('.uc-markdown a');
      if (link) {
        if (this.openInNewWindow) {
          ev.preventDefault();
          window.open(link.href, '_blank');
          return;
        }
        return;
      }
    }
  },
  render() {
    const h = arguments[0];
    const css = `text-align: ${this.align};`;
    const innerHTML = this.outHtml;
    return h("article", _mergeJSXProps([{
      "class": "markdown-body uc-markdown",
      "style": css
    }, {
      "domProps": {
        innerHTML
      }
    }, {}, {
      "on": {
        '!click': this.handleClick
      }
    }]));
  }
};
export default Markdown;
//# sourceMappingURL=index.js.map
